// extracted by mini-css-extract-plugin
export default {"container_recipes":"style_container_recipes__a2NP7","container_cards":"style_container_cards__v5D1y"};